import styled from 'styled-components';
import {GameImageBox as BaseGameImageBox} from '../../../single-game/common/boxes/game-image/game-image.box';

export const GameImageDefaultBox = styled(BaseGameImageBox)`
    cursor: default;
`;
